var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Analytics } from '../../helpers/analyticsMiddleware';
import { assignIn } from 'lodash';
import { AdditionalInfoView } from './typings';
export var getRejectedFilesErrors = function (rejectedFiles) {
    var errorMap = {};
    rejectedFiles
        .filter(function (_a) {
        var errors = _a.errors;
        return errors.length;
    })
        .forEach(function (_a) {
        var errors = _a.errors;
        var _b = errors[0], message = _b.message, code = _b.code;
        if (!errorMap[code]) {
            errorMap[code] = message;
        }
    });
    return errorMap;
};
export var acceptedFileToRejectedFile = function (file, errors) {
    if (errors === void 0) { errors = []; }
    return ({
        file: file,
        errors: errors
    });
};
export var getTotalFileSize = function (files) {
    return files.reduce(function (totalSize, file) {
        var fileSize = 'errors' in file ? file.file.size : file.size;
        return totalSize + fileSize;
    }, 0);
};
export var createAcceptedFile = function (file, alreadySubmitted) {
    if (alreadySubmitted === void 0) { alreadySubmitted = false; }
    return assignIn(file, { alreadySubmitted: alreadySubmitted });
};
var getReviewPageSubfunctionValue = function (acceptedFiles, userComment) {
    if (acceptedFiles.length > 1 && userComment) {
        return Analytics.MultipleDocumentsAndComments;
    }
    if (acceptedFiles.length > 1 && !userComment) {
        return Analytics.MultipleDocuments;
    }
    if (acceptedFiles.length === 1 && userComment) {
        return Analytics.SingleDocumentAndComments;
    }
    if (acceptedFiles.length === 1 && !userComment) {
        return Analytics.SingleDocument;
    }
    if (!acceptedFiles.length && userComment) {
        return Analytics.CommentsOnly;
    }
    return null;
};
export var getAdditionalInfoAnalyticsEventOptions = function (currentView, acceptedFiles, userComment) {
    var _a;
    var analytics = (_a = {},
        _a[AdditionalInfoView.Upload] = {
            pageName: Analytics.Start
        },
        _a[AdditionalInfoView.DeleteConfirmation] = {
            pageSubFunction: Analytics.Upload_Documents,
            pageName: Analytics.DeleteConfirmation
        },
        _a[AdditionalInfoView.CancelConfirmation] = {
            pageSubFunction: Analytics.Upload_Documents,
            pageName: Analytics.CancelConfirmation
        },
        _a[AdditionalInfoView.Review] = {
            pageName: Analytics.Review,
            pageSubFunction: getReviewPageSubfunctionValue(acceptedFiles, userComment)
        },
        _a[AdditionalInfoView.SubmitConfirmation] = {
            pageName: Analytics.Complete
        },
        _a);
    return __assign({ pageKind: Analytics.Dispute, pageFunction: Analytics.AdditionalInfo }, analytics[currentView]);
};
//# sourceMappingURL=helpers.js.map